import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider, RouterProviderProps } from 'react-router-dom';
import { Store } from 'redux';
import './init-pack';
import ThemeProvider from 'ui-lib/ThemeProvider';
import AppSplashScreen from '../AppSplashScreen';
import UnleashProvider from '../../services/UnleashProvider';

interface Props {
  store: Store;
  router: RouterProviderProps['router'];
  mixedTheme: boolean;
}

const ApplicationPack = ({ store, router, mixedTheme }: Props) => {
  const content = <UnleashProvider>
    <AppSplashScreen mixedTheme={mixedTheme}>
      <RouterProvider router={router} />
    </AppSplashScreen>
  </UnleashProvider>;

  return (
    <Provider store={store}>
      {mixedTheme ? content : <ThemeProvider allowDarkMode>{content}</ThemeProvider>}
    </Provider>
  );
};

export default ApplicationPack;
